import type { ExperienceEntry } from '@/types/content'
import styles from './ExperienceSection.module.css'

interface ExperienceSectionProps {
  /** Section label, e.g. "Experience" or "Education". */
  label: string
  entries: readonly ExperienceEntry[]
  /** Hides the per-role summary and stack, for the education list. */
  compact?: boolean
}

/**
 * A labelled timeline. Used twice on the about page — once for roles and once
 * for education — which is why the label and entries are both props.
 */
export const ExperienceSection = ({
  label,
  entries,
  compact = false,
}: ExperienceSectionProps) => (
  <div className={styles.block}>
    <h2 className={`t-14 ${styles.label}`}>{label}</h2>
    <ul className={styles.list}>
      {entries.map((entry) => (
        <li key={entry.id} className={styles.entry}>
          <p className={`t-12 ${styles.period}`}>{entry.period}</p>
          <h3 className="t-14">{entry.role}</h3>
          <p className={`t-12 ${styles.organisation}`}>{entry.organisation}</p>

          {!compact && entry.summary && (
            <p className={`t-12 ${styles.summary}`}>{entry.summary}</p>
          )}

          {!compact && entry.stack && (
            <ul className={styles.stack}>
              {entry.stack.map((item) => (
                <li key={item} className={styles.chip}>
                  {item}
                </li>
              ))}
            </ul>
          )}
        </li>
      ))}
    </ul>
  </div>
)
